import React, { ReactNode, useState } from 'react'
import { useIntl } from 'gatsby-plugin-react-intl'
import { StaticImage } from 'gatsby-plugin-image'
import * as styles from './CookieBanner.module.scss'
import Popup from '../Popup/Popup'
import CookieOptions, { ConfidentialitySettings } from '../confidentiality-settings/ConfidentialitySettings'

declare global {
  interface Window { loadGtm: (() => void) | null }
}

interface CookieBannerProps {
  onSave(): void
}
const CookieBanner: React.FC<CookieBannerProps> = ({ onSave }) => {
  const t = useIntl()
  const [showSettingsPopup, setShowSettingsPoupup] = useState(false)

  function saveSettings (confidentialitySettings: ConfidentialitySettings) {
    localStorage.setItem('ngStorage-userProperty-privacySettings-codingame', JSON.stringify(confidentialitySettings))
    onSave()
    if (confidentialitySettings.analytics && window.loadGtm != null) {
      // load gtm/analytics after setting confidentialitySettings in window
      window.loadGtm()
    }
  }

  function handleAcceptAll () {
    saveSettings({
      analytics: true,
      facebook: true,
      advertising: true
    })
  }

  function handleRefuseAll () {
    saveSettings({
      analytics: false,
      facebook: false,
      advertising: false
    })
  }

  return (
    <>
      {showSettingsPopup && (
        <Popup onClose={() => setShowSettingsPoupup(false)}>
          <CookieOptions
            onSubmit={saveSettings}
          />
        </Popup>
      )}

      <div className={styles.container} ng-if='!$ctrl.cookiesBannerConfig.seen'>
        <div className={styles.header}>
          <StaticImage
            className={styles.icon}
            src='./assets/cookies.png'
            alt=''
            width={32}
            height={32}
          />
          <div className={styles.sentence}>
            <p>
              {t.formatMessage({ id: 'cookiesBanner.sentence1' })}
            </p>
            <p>
              <span>
                {t.formatMessage({ id: 'cookiesBanner.sentence2' }, {
                  options: (content: ReactNode) => (
                    <button
                      className={styles.link}
                      onClick={() => setShowSettingsPoupup(true)}
                    >
                      {content}
                    </button>
                  )
                })}
              </span>
              {' '}
              <a
                className={styles.link}
                href='/legal/cookies-policy'
              >
                {t.formatMessage({ id: 'cookiesBanner.seeDetails' })}
              </a>
            </p>
          </div>
        </div>
        <div className={styles.buttonsContainer}>
          <button
            className={`${styles.button} ${styles.buttonAccept}`}
            onClick={() => handleAcceptAll()}
          >
            {t.formatMessage({ id: 'cookiesBanner.accept' })}
          </button>
          <button
            className={`${styles.button} ${styles.buttonRefuse}`}
            onClick={() => handleRefuseAll()}
          >
            {t.formatMessage({ id: 'cookiesBanner.refuse' })}
          </button>
          <button
            className={`${styles.button} ${styles.buttonConfigure}`}
            onClick={() => setShowSettingsPoupup(true)}
          >
            {t.formatMessage({ id: 'cookiesBanner.configure' })}
          </button>
        </div>

      </div>
    </>
  )
}

export default CookieBanner
